export const MEDICATION_CATEGORIES = [
  'Antibiótico',
  'Vitamina',
  'Vacuna',
  'Desparasitante',
  'Antiinflamatorio',
  'Analgésico',
  'Suplemento',
  'Hormonal',
  'Protector Hepático',
  'Otros'
];

export const MEDICATION_PRESENTATIONS = [
  { value: 'sobre', label: 'Sobre' },
  { value: 'galon', label: 'Galón' },
  { value: 'garrafon', label: 'Garrafón' },
  { value: 'dosis', label: 'Dosis' },
  { value: 'tableta', label: 'Tableta' },
  { value: 'capsula', label: 'Cápsula' },
  { value: 'ampolla', label: 'Ampolla' },
  { value: 'frasco', label: 'Frasco' },
  { value: 'saco', label: 'Saco' },
  { value: 'litro', label: 'Litro' },
  { value: 'tarro', label: 'Tarro' },
  { value: 'funda', label: 'Funda' },
];

export const MEDICATION_UNITS = [
  { value: 'unidad', label: 'Unidad' },
  { value: 'litro', label: 'Litro (L)' },
  { value: 'ml', label: 'Mililitros (ml)' },
  { value: 'kg', label: 'Kilogramo (kg)' },
  { value: 'gramo', label: 'Gramos (g)' },
  { value: 'mg', label: 'Miligramos (mg)' },
  { value: 'lb', label: 'Libras (lb)' },
];

export const ADMINISTRATION_TYPES = [
  { value: 'premix', label: 'Premix' },
  { value: 'oral', label: 'Oral' },
  { value: 'inyectable', label: 'Inyectable' },
];
